<script setup lang="ts">
import { onUpdated } from "vue";
import { defineProps } from "vue";


const props = defineProps({
  show: Boolean,
  showForm: Boolean,
  lotId: String,
  isWideScreen: Boolean
})
onUpdated(()=>{
  const testScript = document.createElement("script");
  testScript.innerHTML = `hbspt.forms.create({
                          portalId: "23487292",
                          formId: "65bfe3fb-f298-4503-a6c3-f561944dcd7a",
                          region: "na1"
                });`
  var modalTest = document.querySelector('#formEmbed');
  modalTest?.appendChild(testScript);
  var interval = setTimeout(()=>{
    var inputData = document.querySelector('iframe');
    if(inputData){
      var test = inputData!.contentWindow!.document.querySelector('input[name=homesite]');
      test!.value = props.lotId;
    }
  }, 1000);

})

</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="{ 'wide-screen-modal': isWideScreen}">
          <button
                class="modal-close-button"
                @click="$emit('close')"
              ><img class="close-img" src="./../assets/x-icon.svg" /></button>
          <div class="modal-header">
            <slot name="header">default header</slot>
          </div>
          <div class="modal-body" v-if="!showForm">
            <slot name="body">default body</slot>
          </div>
          <div class="modal-form" id="formEmbed" v-else>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  font-family:'Roboto', sans-serif;
  font-size: larger;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 22rem;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.6rem rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  color: #131E29;
}

.wide-screen-modal{
  margin-right: calc(50vw - 25.625rem);
}
.modal-body{
      display: flex;
      flex-direction: column !important;
      max-height: 90vh;
      overflow: auto;
      padding-bottom: 0.5rem;
      text-align: left;
      margin: 0.7rem 1rem 1rem 1rem;
  }

#formEmbed{
  margin-right: auto;
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 1em;
}

@media only screen and (max-width: 480px){

  .modal-body{
      flex-direction: column !important;
      align-items: flex-start !important;
  }
}
@media only screen and (max-width: 620px){
.modal-container {
     width: 90%;
  }
  .modal-body{
      flex-direction: column !important;
      align-items: center !important;
  }
}

.modal-header {
  text-align: left;
  padding-top: 1rem;
  padding-left: 1rem;
  color: #494949;
  display: flex;
  flex-direction: column;
  font-weight: bold;
}

.modal-close-button {
  float: right;
  position: relative;
  border: none;
  top: 0.8rem;
  right: 1rem;
  border: #6b9ba0 3px solid;
  border-radius: 3px;
  padding-top: 3px;
  background-color: #fff;
  background-size: contain;
}
.close-img {
    width: 0.8rem;
    height: 0.8rem;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>